// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","682":"component---src-pages-about-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"1c88c88fbcf5da94af66","682":"b07fc8eaa324af230788","883":"c8ac8fdd7169c5ddee6d"}[chunkId] + ".js";
};